type RemoveUndefined<T> = [T] extends [undefined] ? T : Exclude<T, undefined>
type ObjectEntries<T> = {
  [K in keyof T]-?: [K, RemoveUndefined<T[K]>]
}[keyof T]

export const getEntries = <T extends object>(obj: T) => Object.entries(obj) as ObjectEntries<T>[]
